var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('CoreSidedrawer'),_c('CoreNavBar'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),(_vm.$route.meta.name !== 'Maps')?_c('CoreFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }